import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LogoImage from '../assets/logo.png';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect if already authenticated
  React.useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from?.pathname || '/admin';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const result = await login(username, password);
      
      if (result.success) {
        const from = location.state?.from?.pathname || '/admin';
        navigate(from, { replace: true });
      } else {
        setError(result.error || 'Invalid username or password');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#E9E7F4] flex items-center justify-center px-4">
      <div className="bg-white rounded-[32px] p-8 md:p-12 max-w-md w-full shadow-lg">
        <div className="text-center mb-8">
          <img 
            src={LogoImage} 
            alt="Logo" 
            className="mx-auto mb-6"
            width={85}
            height={51}
          />
          <h1 className="text-3xl md:text-4xl font-bold text-[#03002F] font-cabinet mb-2">
            Admin Login
          </h1>
          <p className="text-[#282727] font-satoshi text-sm">
            Enter your credentials to access the dashboard
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="username" className="block font-bold text-[#282727] font-satoshi text-sm md:text-base mb-2">
              Username
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-sm font-medium px-4 py-3 h-[57px] bg-[#E3E3E3] focus:outline-none focus:ring-2 focus:ring-[#5F5CF0]"
              placeholder="Enter username"
              required
            />
          </div>

          <div>
            <label htmlFor="password" className="block font-bold text-[#282727] font-satoshi text-sm md:text-base mb-2">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-sm font-medium px-4 py-3 h-[57px] bg-[#E3E3E3] focus:outline-none focus:ring-2 focus:ring-[#5F5CF0]"
              placeholder="Enter password"
              required
            />
          </div>

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-[8px] text-sm font-satoshi">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full bg-[#5F5CF0] rounded-[8px] py-4 text-white font-satoshi font-bold text-base hover:bg-[#4d4bd6] transition-colors ${
              isLoading ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;

